import {
  GET_DASHBOARD_STATS_REQUEST,
  GET_DASHBOARD_STATS_SUCCESS,
  GET_DASHBOARD_STATS_FAILURE,
  GET_MONTHLY_SCAN_STATS_REQUEST,
  GET_MONTHLY_SCAN_STATS_SUCCESS,
  GET_MONTHLY_SCAN_STATS_FAILURE,
  GET_LICENSE_USAGE_REQUEST,
  GET_LICENSE_USAGE_SUCCESS,
  GET_LICENSE_USAGE_FAILURE
} from '../../constants/dashboardConstant/dashboardConstants';

export const getDashboardStatsRequest = (itSalesId, oemId = null) => ({
  type: GET_DASHBOARD_STATS_REQUEST,
  payload: { itSalesId, oemId }
});

export const getDashboardStatsSuccess = (data) => ({
  type: GET_DASHBOARD_STATS_SUCCESS,
  payload: data
});

export const getDashboardStatsFailure = (error) => ({
  type: GET_DASHBOARD_STATS_FAILURE,
  payload: error
});

export const getMonthlyScanStatsRequest = (oemId) => ({
  type: GET_MONTHLY_SCAN_STATS_REQUEST,
  payload: oemId
});

export const getMonthlyScanStatsSuccess = (data) => ({
  type: GET_MONTHLY_SCAN_STATS_SUCCESS,
  payload: data
});

export const getMonthlyScanStatsFailure = (error) => ({
  type: GET_MONTHLY_SCAN_STATS_FAILURE,
  payload: error
});

export const getLicenseUsageRequest = (itSalesId, licenseId) => ({
  type: GET_LICENSE_USAGE_REQUEST,
  payload: { itSalesId, licenseId }
});

export const getLicenseUsageSuccess = (data) => ({
  type: GET_LICENSE_USAGE_SUCCESS,
  payload: data
});

export const getLicenseUsageFailure = (error) => ({
  type: GET_LICENSE_USAGE_FAILURE,
  payload: error
});